import { Flex } from '@chakra-ui/react';
import { Button, Card, Container, Divider, Group, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import type { Plan } from '@melio/subscriptions-api';

import { SubscriptionCheckoutBillingTotal } from './components/SubscriptionCheckoutBillingTotal';
import { SubscriptionCheckoutPromoCode } from './components/SubscriptionCheckoutPromoCode';
import { SubscriptionCheckoutSummaryPlan } from './components/SubscriptionCheckoutSummaryPlan';

type SubscriptionCheckoutSummaryProps = {
  columns: number;
  total: number;
  subTotal: number;
  planName: Plan['title'];
  isPlanSaving: boolean;
  onSubmit: () => void;
};
export const SubscriptionCheckoutSummary = ({
  columns,
  subTotal,
  planName,
  isPlanSaving,
  onSubmit,
}: SubscriptionCheckoutSummaryProps) => {
  const { formatMessage } = useMelioIntl();

  return (
    <Flex flexDir="column" width="full" flex={{ xs: 'none', m: columns }}>
      <Container paddingBottom="s">
        <Text as="h2" textStyle="body2Semi" color="neutral.darker">
          {formatMessage('activities.subscription.checkout.summary.title')}
        </Text>
      </Container>

      <Card variant="flat">
        <Container>
          <Group variant="vertical" spacing="m">
            <SubscriptionCheckoutSummaryPlan planName={planName} />
            <Divider />
            <SubscriptionCheckoutPromoCode />
            <SubscriptionCheckoutBillingTotal subTotal={subTotal} />

            <Button
              label={formatMessage('activities.subscription.checkout.summary.submit')}
              size="large"
              onClick={onSubmit}
              isLoading={isPlanSaving}
              data-testid="subscription-checkout-submit"
            />
            <Text textStyle="body4" color="neutral.darker">
              {formatMessage('activities.subscription.checkout.summary.disclaimer')}
            </Text>
          </Group>
        </Container>
      </Card>
    </Flex>
  );
};
